import React from 'react';
import { motion } from 'framer-motion';
import type { HookContent } from '../../types/salesPage';
interface HookSectionProps {
  content: HookContent;
}
export function HookSection({
  content
}: HookSectionProps) {
  return <section aria-labelledby="hook-title" className="border-t border-white/[0.07] bg-carbon px-5 py-14 sm:px-6 md:py-20" data-id="element-128" data-mp="1k81r19ifshwv">
      <div className="mx-auto max-w-5xl" data-id="element-129" data-mp="1p1ef9ij7emp3">
        <header className="mx-auto max-w-2xl text-center" data-id="element-130" data-mp="1tzfyc3gmqm0k">
          {content.eyebrow && <p className="font-mono text-[9.5px] uppercase tracking-[0.22em] text-gold md:text-[10px]" data-id="element-131" data-mp="1ywy5ppf00t6g">
              {content.eyebrow}
            </p>}
          <h2 id="hook-title" className="font-serif text-[24px] font-semibold italic leading-tight text-ivory sm:text-[30px] md:text-[38px]" data-id="element-132" data-mp="22xi0imc3nkpf">
            {content.title}
          </h2>
          <p className="mt-4 text-[14.5px] font-light leading-relaxed text-ash md:text-[16px]" data-id="element-133" data-mp="dk4yj3rgm8rh">
            {content.intro}
          </p>
        </header>

        <div className="relative mt-10 grid gap-4 md:mt-12 md:grid-cols-2 md:gap-6" data-id="element-134" data-mp="1p28y66qzbu5h">
          <span aria-hidden="true" className="absolute left-1/2 top-1/2 hidden h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-gold/40 bg-ink font-serif text-[15px] italic text-gold-soft md:flex" data-id="element-135" data-mp="1k8o7z0vmo4gu">
            vs
          </span>

          {content.panels.map((panel, i) => <motion.article key={panel.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1,
          ease: 'easeOut'
        }} className="overflow-hidden rounded-sm border border-white/10 bg-panel" data-id="element-136" data-mp="23xoxorabwi99" data-mpi={i}>
              <div className="relative" data-id="element-137" data-mp="il5ddkcjfovr">
                <img src={panel.image.src} alt={panel.image.alt} loading="lazy" decoding="async" className="h-44 w-full object-cover sm:h-52" data-id="element-138" data-mp="ijao5tu8halv" />
                <div aria-hidden="true" className="absolute inset-0 bg-[linear-gradient(0deg,rgba(26,30,36,0.95)_2%,rgba(26,30,36,0.25)_60%,transparent_100%)]" data-id="element-139" data-mp="b1mkmmdhsh9z" />
                <span className="absolute bottom-3 left-4 font-mono text-[9.5px] uppercase tracking-[0.16em] text-gold-soft" data-id="element-140" data-mp="1b1d29fuc2ex">
                  {panel.label}
                </span>
              </div>
              <div className="px-5 pb-6 pt-4 sm:px-6" data-id="element-141" data-mp="3ogskvd3eejpe">
                <h3 className="font-serif text-[18px] font-semibold leading-snug text-ivory sm:text-[20px]" data-id="element-142" data-mp="3oe66oum055y7">
                  {panel.title}
                </h3>
                <p className="mt-2.5 text-[14px] font-light leading-relaxed text-smoke" data-id="element-143" data-mp="3ej4j437dkbxq">
                  {panel.text}
                </p>
              </div>
            </motion.article>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mx-auto mt-10 max-w-2xl border-y border-gold/25 py-5 text-center font-serif text-[18px] font-semibold leading-snug text-gold-soft md:text-[22px]" data-id="element-144" data-mp="2zvwb1b9d4mpz">
          {content.closing}
        </motion.p>
      </div>
    </section>;
}